import { Link } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Chip from "@mui/material/Chip";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageGuide from "components/admin/PageGuide";
import Footer from "examples/Footer";
import PageCard from "components/admin/PageCard";
import AdminTable from "components/admin/AdminTable";
import { useFetch } from "components/admin/hooks";
import api from "api/client";

/*
 * Trang chỉ xem: các sự kiện máy chủ đang chạy theo lịch trong code.
 * Đang chạy lên đầu; mã kỹ thuật (type) chỉ hiện khi rê chuột; chỉ đường sang Mùa sự kiện để tạo / sửa.
 */

function Events() {
  const events = useFetch(() => api.get("/api/admin/events"), [], 10000);
  const rows = [...(events.data || [])].sort((a, b) => Number(b.active) - Number(a.active));
  const running = rows.filter((e) => e.active).length;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <PageGuide page="events" />
        <Alert
          severity="info"
          sx={{ mb: 3 }}
          action={
            <MDButton size="small" variant="text" color="info" component={Link} to="/event-seasons">
              Mở Mùa sự kiện
            </MDButton>
          }
        >
          Trang này chỉ để <b>xem</b> các sự kiện có sẵn trong game. Muốn <b>tạo hoặc sửa</b> sự
          kiện có quà, bảng xếp hạng, lịch chạy thì vào trang <b>Mùa sự kiện</b>.
        </Alert>
        <PageCard
          title="Sự kiện trong game"
          subtitle={
            events.data
              ? `${running} đang chạy · ${
                  rows.length - running
                } chưa tới giờ hoặc đã hết · tự cập nhật mỗi 10 giây`
              : "Tự cập nhật mỗi 10 giây"
          }
          color="warning"
          noPadding
          actions={
            <MDButton size="small" variant="outlined" color="white" onClick={() => events.reload()}>
              <Icon>refresh</Icon>&nbsp;Tải lại
            </MDButton>
          }
        >
          {events.error && (
            <MDBox px={2}>
              <Alert severity="error">
                Không lấy được danh sách sự kiện ({events.error}). Máy chủ game có thể đang tắt.
              </Alert>
            </MDBox>
          )}
          <AdminTable
            loading={events.loading}
            rows={rows}
            rowKey="type"
            emptyText="Máy chủ chưa có sự kiện nào"
            columns={[
              {
                key: "name",
                label: "Sự kiện",
                render: (e) => (
                  <Tooltip title={`mã kỹ thuật: ${e.type}`}>
                    <MDTypography variant="button" fontWeight="medium">
                      {e.name}
                    </MDTypography>
                  </Tooltip>
                ),
              },
              {
                key: "active",
                label: "Trạng thái",
                render: (e) => (
                  <MDBox display="flex" gap={0.5} flexWrap="wrap">
                    <Chip
                      size="small"
                      color={e.active ? "success" : "default"}
                      icon={<Icon>{e.active ? "play_circle" : "schedule"}</Icon>}
                      label={e.active ? "Đang chạy" : "Chưa tới giờ / đã hết"}
                    />
                    {!e.initialized && (
                      <Tooltip title="Máy chủ chưa chuẩn bị xong sự kiện này (thường gặp ngay sau khi khởi động). Kéo dài thì báo kỹ thuật.">
                        <Chip size="small" color="warning" label="Đang chuẩn bị" />
                      </Tooltip>
                    )}
                    {e.needRemove && (
                      <Tooltip title="Sự kiện đã xong, máy chủ sẽ tự gỡ khỏi danh sách.">
                        <Chip size="small" color="error" label="Sắp kết thúc" />
                      </Tooltip>
                    )}
                  </MDBox>
                ),
              },
              {
                key: "details",
                label: "Tình hình hiện tại",
                wrap: true,
                render: (e) =>
                  e.details?.length ? (
                    <MDBox component="ul" m={0} pl={2}>
                      {e.details.map((d) => (
                        <MDTypography key={d} component="li" variant="caption" color="text">
                          {d}
                        </MDTypography>
                      ))}
                    </MDBox>
                  ) : (
                    "-"
                  ),
              },
              {
                key: "items",
                label: "Vật phẩm dùng trong sự kiện",
                wrap: true,
                render: (e) =>
                  e.items?.length ? (
                    <MDBox display="flex" gap={0.5} flexWrap="wrap">
                      {e.items.map((i) => (
                        <Chip key={i.name} size="small" variant="outlined" label={i.name} />
                      ))}
                    </MDBox>
                  ) : (
                    "-"
                  ),
              },
            ]}
          />
        </PageCard>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Events;
